export default {
    'ERRORS.ONLY.ONE.SLOT': 'Désolé ! Vous ne pouvez pas créer plus d\'une indisponibilité/créneau réservé dans le même jour.',
    'ERRORS.PERMISSION': 'Désolé, vous n\'avez pas l\'autorisation d\'accéder à cette fonctionnalité',
    'ERRORS.LOGIN.PASSWORD': 'L\'email ou le mot de passe est invalide. Réessayez',
    'ERRORS.EVENT.PAST': 'Les événements passés ne peuvent être modifiés',
};
